import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

function CounterIcons({
  pages = [],
  currentPage = 0,
}) {
  return (
    <div className="d-flex justify-content-center">
      {pages.map((p, i) => {
        if (i === currentPage) {
          return <FontAwesomeIcon key={p.title} className="me-4 text-cyan" icon={faCircle} />;
        }
        return <FontAwesomeIcon key={p.title} style={{ color: 'lightgrey' }} className="me-4" icon={faCircle} />;
      })}
    </div>
  );
}

export default CounterIcons;
